import { Route } from '../config/routes'

export interface Authentication {
  authenticated: boolean
  persistent: boolean
  persistentOptIn?: boolean
  verificationRequired: boolean
}

// Remove this
export interface CodeVerificationDirective {
  skipCodeVerification: boolean
}

export const unauthenticate = (): Authentication => ({
  authenticated: false,
  persistent: false,
  verificationRequired: false,
})

export const authenticate = (verificationRequired: boolean, persistent: boolean, persistentOptIn: boolean = false): Authentication => ({
  authenticated: true,
  verificationRequired,
  persistent,
  persistentOptIn,
})

export const persistentSession = (active: boolean, verify: boolean = false): Authentication => ({
  authenticated: active,
  verificationRequired: verify,
  persistent: active,
  persistentOptIn: false,
})

export enum AuthenticationErrors {
  IncorrectPassword,
  AccountLocked,
  AccountDisabled,
  FailureMaxAttempts,
  TooManyOTPRequests,
  PaywatchCheckFailed,
  OtherError,
}

export interface MobileLogin {
  isMobileLogin: boolean
  mobile?: string
  dateOfBirthVerificationRequired: boolean
  verifiedRoute?: Route // next route after DOB is verified
  hasSeenChallenge: boolean
}
/* Custom Headers */
export interface PersistentLoginHeaders extends OAuth2faHeaders {
  Authorization?: string
  [key: string]: string | undefined
}

export interface OAuth2faHeaders {
  'oauth-user-agent'?: string
  'oauth-device-fingerprint'?: string
  'oauth-client-ip'?: string
  'oauth-login-time'?: string
}

/* Data */

export interface FingerPrint {
  fingerprint: string
  language: string
  timezoneOffset: number
  resolution: string
}

/* API Request / Responses */

export interface AuthLoginRequest {
  username: string
  password: string
}

export interface AuthLoginResponse {
  user: {
    id: number
    name: string
    requires2fa: boolean
    shouldAllowEmail: boolean
  }
  status: 'success' | string
}

export interface EmailLinkReset {
  consumerEmail: string
}
export interface MobileLinkReset {
  consumerPhoneNumber: string
  phoneNumberCountryCode: string
}

export type SendResetLinkRequest = EmailLinkReset | MobileLinkReset

export const CHECKOUT_TOKEN_REQUEST = 'CHECKOUT_TOKEN_REQUEST'
export const AFTERPAY_CHECKOUT_LOGIN_TOKEN = 'AFTERPAY_CHECKOUT_LOGIN_TOKEN'
export const CASH_CHECKOUT_TOKEN = 'CASH_CHECKOUT_TOKEN'

export interface CheckoutTokenResponse {
  type: typeof AFTERPAY_CHECKOUT_LOGIN_TOKEN | typeof CASH_CHECKOUT_TOKEN
  payload: string
}

export type LoginMethodTypes = 'Web Password' | 'Web Persistent' | 'OTP' | '2fa' | 'Biometric Login' | 'Trusted Checkout (OAuth)'

export interface LoginAttemptEventParams {
  is2fa: boolean
}
